import { Link } from 'react-router-dom';
import { categories, MAIN_SITE_URL } from '@/mocks/categories';
import { articleList } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer group">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-database-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg text-white whitespace-nowrap group-hover:text-primary-300 transition-colors">
                VigorBuy Spreadsheet
              </span>
            </Link>
            <p className="text-xs md:text-sm text-foreground-300 leading-relaxed mb-4">
              Your ultimate resource for organized product discovery, spreadsheet shopping guides, and curated product databases.
            </p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-white text-xs font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Buy It Now <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm text-white mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Home</Link>
              <Link to="/vigorbuy-spreadsheet-guide" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Shopping Guide</Link>
              <a href="#categories" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Categories</a>
              <a href="#guide" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Guide</a>
              <a href="#articles" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Expert Guides</a>
              <a href="#safety" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Safety</a>
              <a href="#faq" className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">FAQ</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-white mb-4">Top Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-white mb-4">More Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-200/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-300">
            &copy; 2026 VigorBuy Spreadsheet. All rights reserved. | Built for smarter spreadsheet shopping.
          </p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
          >
            Powered by VigorBuy Spreadsheet <i className="ri-external-link-line text-xs"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}